// extracted by mini-css-extract-plugin
export default {"defaultTable":"table_defaultTable__Z6kJz"};